export default {
  path: 'loginIndex',
  component: () => import(/* webpackChunkName: "login" */ '@/pages/passport/SlideLogin'),
}